"use client";

import * as React from "react";

import { MenuButton } from "@headlessui/react";

export type DropdownButtonProps = React.ComponentProps<typeof MenuButton>;

const DropdownButton = React.forwardRef<HTMLButtonElement, DropdownButtonProps>((props, ref) => {
  return (
    <MenuButton
      ref={ref}
      as="div"
      {...props}
    />
  );
});

DropdownButton.displayName = "DropdownButton";

export { DropdownButton };
